import React, { FC, useEffect, useState } from "react";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";

import DropZone from "~/components/DropZone";
import TextArea from "~/shared/ui/Fields/TextArea";
import { NOTIFICATIONS } from "~/constans/notifications";
import { useSetUploads } from "~/entity/Uploads/hooks/useSetUploads";
import { useSetLocationData } from "~/hooks/locationData";
import { uploadFile } from "~/libs/uploadFile";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import type { UploadDataFormProps } from "~/widgets/UploadDataModal";

import s from "./UploadIndicatorsForm.less";

const UploadIndicatorsForm: FC<UploadDataFormProps> = ({
  formId,
  onClose,
  refetch,
  onStateChange,
}) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const [file, setFile] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const { handleSubmit, control } = useForm();

  const { uploadDealerMetricFile } = useSetUploads();

  const [addNotificationMutation] = useAddNotificationMutation({});
  const fallBack = () => {
    addNotificationMutation({
      variables: {
        type: NOTIFICATIONS.error,
        content: t("common.data_uploaded_error"),
      },
    });
  };

  useEffect(() => {
    onStateChange({
      loading: uploadDealerMetricFile.isLoading,
      submitDisabled: Object.keys(file).length === 0 || isDisabled,
    });
  }, [uploadDealerMetricFile.isLoading, file, isDisabled, onStateChange]);

  const onSubmit = async (data) => {
    const { id: fileId } = (await uploadFile(file as File, fallBack)) || {};

    if (fileId) {
      uploadDealerMetricFile.mutate(
        {
          type: "indicatorValues",
          fileId: Number(fileId),
          description: data?.description,
        },
        {
          onSuccess: () => {
            refetch?.();
            onClose();
          },
          onError: () => {
            fallBack();
          },
        },
      );

      setData("page", 0);
      setIsDisabled(true);
    }
  };

  return (
    <form id={formId} className={s.form} onSubmit={handleSubmit(onSubmit)}>
      <TextArea
        name="description"
        label={t("uploads.upload_description")}
        control={control}
        vertical
      />
      <DropZone
        getFiles={(files) => setFile(files[0])}
        accept={".csv"}
        isOne
        showFormats
      />
    </form>
  );
};

export default UploadIndicatorsForm;
